import { render, staticRenderFns } from "./SiloCreate.vue?vue&type=template&id=755e85e5"
import script from "./SiloCreate.vue?vue&type=script&lang=js"
export * from "./SiloCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports